import axios from 'axios';
export default async (userId: string): Promise<boolean> => {
    let response: { data?: boolean };
    try {
        response = await axios.get('/api/v2/certification-training/public/user-is-certified/' + userId);
    } catch (e) {
        console.error('axios.get threw an exception.', userId, e);
        return false;
    }
    return response.data;
};
